/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { connect } from 'react-redux' // Npm: React Redux for state management.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import MncDeleteMutation from './__mutation__/index.mnc.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, refetch }) => {
  // Hook assignment.
  const [MutationMncDelete, MutationMncDeleteResponse] = useMutation(MncDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationMncDeleteResponse.loading} onConfirm={() =>
      MutationMncDelete({
        'variables': {
          'mncId': passOn?.mncId
        }
      }).then(i => {
        // Style Guide.
        toast(i?.data?.MncDelete?.message)

        // Refresh table after delete.
        refetch?.()

        // Report success.
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))} isLoading={MutationMncDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func,
  'refetch': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
